export default {"src":"/_next/static/media/DBRG.b3947c36.svg","height":18,"width":18};